export enum CalculatorTypes {
    Block = "Block",
    Bag = "Bag",
    Cast = "Cast",
    Mortar = "Mortar",
    Plaster = "Plaster",
    SandboxSand = "SandboxSand",
    FogSand = "FogSand",
}
